export default "__VITE_ASSET__B0wlOUD8__"